import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import PWABanners from './components/PWABanners';
import Footer from './components/Footer';
import Login from './pages/Login';
import Chat from './pages/Chat';
import Feed from './pages/Feed';
import Profile from './pages/Profile';
import Install from './pages/Install';
import Download from './pages/Download';
import Timetable from './pages/Timetable';
import AdminDashboard from './pages/AdminDashboard';

/* SW controller change → reload for updates */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}

const AppRoutes = () => {
  const { token } = useAuth();

  return (
    <>
      <PWABanners />
      {token && <Navbar />}
      <div className={token ? 'md:pb-0 pb-16' : ''}>
        <Routes>
          {/* Public */}
          <Route path="/download"  element={<Download />} />
          <Route path="/install"   element={<Install />} />
          <Route path="/login"     element={token ? <Navigate to="/chat" replace /> : <Login />} />
          <Route path="/"          element={token ? <Navigate to="/chat" replace /> : <Navigate to="/download" replace />} />

          {/* Protected */}
          <Route path="/chat"      element={<PrivateRoute><Chat /></PrivateRoute>} />
          <Route path="/feed"      element={<PrivateRoute><Feed /></PrivateRoute>} />
          <Route path="/profile"   element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/timetable" element={<PrivateRoute><Timetable /></PrivateRoute>} />
          <Route path="/admin"     element={<PrivateRoute adminOnly={true}><AdminDashboard /></PrivateRoute>} />
          <Route path="*"          element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      {token && <Footer />}
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
